export default class ScorecardAnswersViewModel {
    public isActive: boolean = false;
    public templateId: number = 0;
    public sectionId: number = 0;
    public questionId: number = 0;
    public answer: string = '';
}

